import React from 'react'
import { Button } from '../../../../../../../components/Button/Button'
import { useAppDispatch } from '../../../../../../../store/hooks'
import { writeCopyContentToClipboard } from '../../../copy'
import { showToast } from '../../../../../../../store/meetingSummary/display'
import { TrackEvent, useTracking } from '../../../../common/tracking'
import { useMeetingSummaryElementsCopy } from './hooks'

export const MeetingSummaryAgentCopyButton: React.FC = () => {
  const dispatch = useAppDispatch()
  const { tracked } = useTracking()
  const { getCopyContent } = useMeetingSummaryElementsCopy()
  const _handleCopy = async () => {
    await writeCopyContentToClipboard(getCopyContent())
    dispatch(showToast({ variant: 'success', icon: 'bi-check-circle-fill', message: 'Copied to clipboard!' }))
  }

  const handleCopy = tracked(_handleCopy, { eventName: TrackEvent.MEETING_SUMMARY_AGENT_RESULT_COPIED })

  return (
    <Button className='px-2 py-1 button-medium' variant='header' onClick={handleCopy}>
      <i className='bi bi-copy' />
      Copy
    </Button>
  )
}
